import { ROUNDING_MODES } from './quoteRounding';

export const VENTILATION_MODES = {
  AMOUNT: 'amount',
  COST: 'cost',
  HOURS: 'hours',
  LABOR_COST: 'labor_cost',
  MATERIAL_COST: 'material_cost',
  QUANTITY: 'quantity',
  WEIGHTING: 'weighting',
  MANUAL: 'manual',
  FIXED: 'fixed',
  NONE: 'none',
};

export const LINE_TYPES = {
  SERVICE: 'service',
  MATERIAL: 'material',
  SUBCONTRACTING: 'subcontracting',
};

export const ventilationModes = [
  { value: VENTILATION_MODES.AMOUNT, label: 'Prorata montant HT' },
  { value: VENTILATION_MODES.COST, label: 'Prorata coût direct' },
  { value: VENTILATION_MODES.HOURS, label: 'Prorata heures' },
  { value: VENTILATION_MODES.LABOR_COST, label: 'Prorata coût main-d’œuvre' },
  { value: VENTILATION_MODES.MATERIAL_COST, label: 'Prorata coût matériel' },
  { value: VENTILATION_MODES.QUANTITY, label: 'Prorata quantités' },
  { value: VENTILATION_MODES.WEIGHTING, label: 'Coefficient de pondération' },
  { value: VENTILATION_MODES.MANUAL, label: 'Manuelle' },
  { value: VENTILATION_MODES.FIXED, label: 'Ligne fixe' },
  { value: VENTILATION_MODES.NONE, label: 'Sans ventilation' },
];

export const lineTypes = [
  { value: LINE_TYPES.SERVICE, label: 'Prestation' },
  { value: LINE_TYPES.MATERIAL, label: 'Achat / matériel' },
  { value: LINE_TYPES.SUBCONTRACTING, label: 'Sous-traitance' },
];

const roundingLabels = {
  none: 'Aucun', cent: 'Centime', euro: 'Euro',
  five_cents: '5 centimes', ten_cents: '10 centimes',
};
export const roundingModes = ROUNDING_MODES.map((value) => ({
  value, label: roundingLabels[value],
}));

export const quoteUnits = ['Ens', 'U', 'm', 'ml'];

export const defaultQuoteSettings = {
  defaultLaborRate: 50,
  defaultVatRate: 20,
  defaultMarginCoefficient: 1.2,
  defaultExpenseAllocationMode: VENTILATION_MODES.COST,
  ventilationMode: VENTILATION_MODES.AMOUNT,
  roundingMode: 'cent',
};
